import { TextInputField } from '@shared/fields/TextInputField';
import { SelectField } from '@shared/fields/SelectField';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper, PageContent } from '@styles/CommonStyles';
import { FormPart } from '@modules/shared/components/FormPart';
import { PARAMS_TYPES_OPTIONS } from '../constants';

const formConfig = [
  {
    width: '100%',
    name: 'name',
    component: TextInputField,
  },
  {
    width: '100%',
    name: 'paramsType',
    options: PARAMS_TYPES_OPTIONS,
    component: SelectField,
  },
];

interface IConfigurationTableProps {
  handleClose: () => void;
}

export const AddNewSubgroupForm = ({ handleClose }: IConfigurationTableProps) => (
  <>
    <PageContent>
      <FormPart sx={{ pb: '8px' }} config={formConfig} />
    </PageContent>

    <CommonButtonWrapper direction="row">
      <CancelButton onClick={handleClose} />
      <SaveButton/>
    </CommonButtonWrapper>
  </>
);
